import React from "react";
import { SidebarProvider, SidebarTrigger, SidebarRail } from "@/components/ui/sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppSidebar } from "@/components/AppSidebar";
import { ModulesProvider } from "@/contexts/ModulesContext";
import { EnhancedMobileNavigation } from "@/components/mobile/EnhancedMobileNavigation";
// import { PWAInstallPrompt } from "@/components/mobile/PWAInstallPrompt";
import { OfflineIndicator } from "@/components/mobile/OfflineIndicator";
import { PWAFeatures } from "@/components/PWAFeatures";
import { useIsMobile } from "@/hooks/use-mobile";
import { useKeyboardShortcuts } from "@/hooks/useKeyboardShortcuts";
import { useBrand } from "@/hooks/useBrand";
import { Outlet } from "react-router-dom";
import { TrialStatusBanner } from "@/components/trial/TrialStatusBanner";
import { SmartHeader } from "@/components/layout/SmartHeader";

export function DashboardLayout() {
  const isMobile = useIsMobile();
  
  // Initialize keyboard shortcuts and branding
  useKeyboardShortcuts();
  useBrand();

  if (isMobile) {
    return (
      <>
        <EnhancedMobileNavigation />
        <OfflineIndicator />
        <div className="pt-16 pb-20 min-h-screen">
          <main className="p-4">
            <Outlet />
          </main>
        </div>
        {/* PWA install banner disabled in this phase */}
        <PWAFeatures />
      </>
    );
  }

  return (
    <TooltipProvider delayDuration={0}>
      <SidebarProvider>
        <ModulesProvider>
          <div className="flex min-h-screen w-full">
            <AppSidebar />
            <SidebarRail />
            <div className="flex-1 flex flex-col">
              {/* Sidebar trigger (visible on all sizes to allow toggling) */}
              <div className="p-2">
                <SidebarTrigger />
              </div>
              <SmartHeader />
              <main className="flex-1 p-6">
                <TrialStatusBanner />
                <Outlet />
              </main>
            </div>
          </div>
          {/* PWA install banner disabled in this phase */}
          <OfflineIndicator />
          <PWAFeatures />
        </ModulesProvider>
      </SidebarProvider>
    </TooltipProvider>
  );
}
